// src/components/Subscribe.jsx
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { subscribeEmail, resetStatus } from '../redux/features/subscriptionSlice';

const Subscribe = () => {
    const [email, setEmail] = useState('');
    const dispatch = useDispatch();
    const { subscribeStatus, error } = useSelector(state => state.subscription);

    useEffect(() => {
        return () => {
            dispatch(resetStatus());
        };
    }, [dispatch]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Basic email validation
        if (!email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
            return;
        }

        try {
            dispatch(subscribeEmail(email));
        } catch (error) {
            console.error('An error occurred while subscribing:', error);
        }
    };

    // Reset form on successful subscription
    useEffect(() => {
        if (subscribeStatus === 'succeeded') {
            setEmail('');
            // Optional: Reset status after a delay
            const timer = setTimeout(() => {
                dispatch(resetStatus());
            }, 3000);
            return () => clearTimeout(timer);
        }
    }, [subscribeStatus, dispatch]);

    return (
        <div className="bg-white p-6 rounded-lg shadow-md max-w-md mx-auto my-8">
            <h3 className="text-xl font-semibold text-gray-800 mb-4">
                Subscribe to Our Newsletter
            </h3>
            <p className="text-gray-600 mb-4">
                Stay updated with our latest blog posts delivered directly to your inbox!
            </p>

            <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Enter your email"
                        className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-green-500 text-gray-500"
                        disabled={subscribeStatus === 'loading'}
                    />
                </div>

                <button
                    type="submit"
                    disabled={subscribeStatus === 'loading'}
                    className={`w-full py-2 px-4 rounded-md text-white font-medium 
                        ${subscribeStatus === 'loading' 
                            ? 'bg-gray-400' 
                            : 'bg-green-600 hover:bg-green-700'
                        } transition-colors`}
                >
                    {subscribeStatus === 'loading' ? 'Subscribing...' : 'Subscribe'}
                </button>

                {subscribeStatus === 'succeeded' && (
                    <p className="text-green-600 text-sm">
                        Successfully subscribed! Thank you for joining our newsletter.
                    </p>
                )}

                {subscribeStatus === 'failed' && (
                    <p className="text-red-600 text-sm">
                        {error || 'An error occurred. Please try again.'}
                    </p>
                )}
            </form>
        </div>
    );
};

export default Subscribe;